import { nothing as o } from "./index-BqflxSah.js";
/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const t = (n) => n != null ? n : o;
export {
  t as ifDefined
};
